import { useState } from "react";
import { HeaderRow, Table, TDHeader, THead } from "../support/SupportStyles";
import customerHealthMetricTypes from "./customerHealthMetricTypes";
import entityTypes from "./entityTypes";
import SensorHealthMetric from "./SensorHealthMetric";

const SensorHealthMetrics = props => {
    const [sortProperty, setSortProperty] = useState();
    const [sortAsc, setSortAsc] = useState(true);
    const groupedMetrics = groupMetricsBySensor(props?.metrics);
    const previousGroupedMetrics = groupMetricsBySensor(props?.previousMetrics);
    const sensorMetricTypes = Object.keys(customerHealthMetricTypes).map(key => customerHealthMetricTypes[key]).filter(metricType => metricType.entityType.key === entityTypes.sensor.key);

    const sortBy = (property) => {
        setSortProperty(property);

        if (sortProperty === property) {
            setSortAsc(prev => !prev);
        } else {
            setSortAsc(false);
        }
    }

    const compareSensors = (a, b) => {
        let aProp, bProp;

        if (sortProperty === 'customerId' || sortProperty === 'entityId') {
            aProp = a?.obj?.[0]?.[sortProperty];
            bProp = b?.obj?.[0]?.[sortProperty];
        } else if (sensorMetricTypes?.some(type => type.key === sortProperty)) {
            aProp = a?.obj?.find(metric => metric?.metricType === sortProperty)?.metricValue;
            bProp = b?.obj?.find(metric => metric?.metricType === sortProperty)?.metricValue;
        }

        if (aProp === undefined) {
            return 1;
        } else if (bProp === undefined) {
            return -1;
        }

        if (sortAsc === false) {
            return aProp < bProp ? 1 : bProp < aProp ? -1 : 0;
        } else {

            return aProp < bProp ? -1 : bProp < aProp ? 1 : 0;
        }
    }

    return <Table>
        <colgroup>
            <col style={{ width: "1%" }} />
        </colgroup>

        <THead>
            <HeaderRow>
                <TDHeader sorted={sortProperty === 'customerId'} ascending={sortAsc} onClick={() => sortBy('customerId')}>Customer ID</TDHeader>
                <TDHeader sorted={sortProperty === 'entityId'} ascending={sortAsc} onClick={() => sortBy('entityId')}>Sensor ID</TDHeader>
                {sensorMetricTypes?.map((metricType, index) => {
                    return <TDHeader key={index} sorted={sortProperty === metricType.key} ascending={sortAsc} onClick={() => sortBy(metricType.key)}>{metricType?.display}</TDHeader>
                })}
            </HeaderRow>
        </THead>

        <tbody>
            {Object.keys(groupedMetrics)
                ?.map(key => ({ key, obj: groupedMetrics?.[key] }))
                ?.sort((a, b) => { return compareSensors(a, b) })
                ?.map(item => {
                    const sensorMetrics = item.obj;
                    const previousSensorMetrics = previousGroupedMetrics?.[item?.key];

                    return <SensorHealthMetric
                        key={item.key}
                        customerId={props.customerId}
                        sensorId={item.key}
                        sensorMetrics={sensorMetrics}
                        sensorMetricTypes={sensorMetricTypes}
                        previousSensorMetrics={previousSensorMetrics}
                    />
                })}
        </tbody>
    </Table>
}

export default SensorHealthMetrics;

const groupMetricsBySensor = metrics => {
    return metrics?.reduce((groups, metric) => {
        const sensorId = metric?.entityId;

        if (!groups[sensorId]) {
            groups[sensorId] = [];
        }

        groups[sensorId].push(metric);
        return groups;
    }, {});
}